import { HEADER_BORDER_HEIGHT, HEADER_HEIGHT } from '../../Header/constants'

const SHIFT_PLAN_SUBHEADER_HEIGHT = 15.25

export const SHIFT_PLAN_HEADER_HEIGHT = HEADER_HEIGHT + HEADER_BORDER_HEIGHT + SHIFT_PLAN_SUBHEADER_HEIGHT
